import React from 'react';
import Icon from '../atoms/Icon';

function PercentCircleIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
      <g
        className='percent-icon-background'
        fill='#69BD28'
        stroke='#000'
        stroke-width='2.41667'
        stroke-miterlimit='10'
      >
        <path d='M15.7083 30.2083C23.7165 30.2083 30.2083 23.7165 30.2083 15.7083C30.2083 7.7002 23.7165 1.20833 15.7083 1.20833C7.70021 1.20833 1.20834 7.7002 1.20834 15.7083C1.20834 23.7165 7.70021 30.2083 15.7083 30.2083Z'/>
      </g>
      
      <g
        className='percent-icon-color'
        fill='#fff'
      >
        <path d='M11.9578 15.5438C9.85045 15.5438 8.51645 14.1131 8.51645 12.3151C8.51645 10.4977 9.85045 9.04775 11.9578 9.04775C14.0844 9.04775 15.4378 10.4977 15.4378 12.3151C15.4378 14.1131 14.0844 15.5438 11.9578 15.5438ZM12.5378 22.1364H10.6624L18.8985 9.24108H20.7931L12.5378 22.1364ZM19.4398 22.3684C17.3324 22.3684 15.9984 20.9378 15.9984 19.1398C15.9984 17.3224 17.3324 15.8724 19.4398 15.8724C21.5471 15.8724 22.9005 17.3224 22.9005 19.1398C22.9005 20.9378 21.5471 22.3684 19.4398 22.3684ZM11.9578 13.4944C12.5764 13.4944 13.0791 13.1464 13.0791 12.3151C13.0791 11.4451 12.5764 11.0971 11.9578 11.0971C11.3584 11.0971 10.8751 11.4451 10.8751 12.3151C10.8751 13.1464 11.3584 13.4944 11.9578 13.4944ZM19.4398 20.3191C20.0585 20.3191 20.5611 19.9904 20.5611 19.1398C20.5611 18.2698 20.0585 17.9218 19.4398 17.9218C18.8211 17.9218 18.3378 18.2698 18.3378 19.1398C18.3378 19.9904 18.8211 20.3191 19.4398 20.3191Z'/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(PercentCircleIcon);
